<template>
  <div
    v-if="labels && labels.length"
    class="special-labels"
    :class="{ details }"
    aria-label="Collection special labels"
  >
    <a
      v-for="label in labels"
      :key="label.id"
      :href="safeUrl(label.hyperlink)"
      :title="label.description"
      target="_blank"
      rel="noopener noreferrer"
      class="special-label"
      @click.stop
    >
      <img
        v-if="safeUrl(label.image_url)"
        :src="label.image_url"
        alt=""
        loading="lazy"
      />
      <span
        ><strong>{{ label.name }}</strong
        ><span v-if="details" class="description">{{
          label.description
        }}</span></span
      >
    </a>
  </div>
</template>
<script>
export default {
  props: { labels: { type: Array, default: () => [] }, details: Boolean },
  methods: {
    safeUrl(value) {
      try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol)
          ? url.href
          : undefined;
      } catch (e) {
        return undefined;
      }
    },
  },
};
</script>
<style scoped>
.special-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 8px 0;
}
.special-label {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  max-width: 100%;
  padding: 5px 8px;
  border: 1px solid #e8dfc6;
  border-radius: 8px;
  background: #fffbef;
  color: #74561c;
  text-decoration: none;
  font-size: 12px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}
.special-label:hover,
.special-label:focus-visible {
  border-color: #a47a28;
  background: #fff3cf;
}
.special-label img {
  width: 144px;
  max-width: 100%;
  aspect-ratio: 4 / 1;
  object-fit: contain;
  flex-shrink: 0;
}
.details .special-label {
  align-items: flex-start;
  padding: 10px;
}
.details img {
  width: 192px;
}
.description {
  display: block;
  color: #666;
  font-size: 12px;
  font-weight: normal;
  white-space: pre-wrap;
}
</style>
